export {getDefaultAttachments} from '@Components/ai-prompt-box/libraries/ai-prompt-box-attachment.library';
import {aiPromptBoxActions} from '@Components/ai-prompt-box/ai-prompt-box.reducer';
import {PromptBoxState} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {getAiChatPromptBoxId} from '@Libraries/ai-chat.library';
import {nextPromptBoxKey} from '@Components/ai-prompt-box/libraries/ai-prompt-box-key.library';

export function sendPrompt(chatId: string, text: string): void {
  window.PMW.redux.store.dispatch(
    aiPromptBoxActions.updateAiPromptBox({
      id: getAiChatPromptBoxId(chatId),
      value: {prompt: text, promptBoxState: PromptBoxState.ACTIVE, focusKey: nextPromptBoxKey(), submitKey: nextPromptBoxKey()},
    })
  );
}

export function focusPromptBox(chatId: string): void {
  window.PMW.redux.store.dispatch(
    aiPromptBoxActions.updateAiPromptBox({
      id: getAiChatPromptBoxId(chatId),
      value: {promptBoxState: PromptBoxState.ACTIVE, focusKey: nextPromptBoxKey()},
    })
  );
}
